import { render, staticRenderFns } from "./HomeDetails.vue?vue&type=template&id=46d7ae2b&scoped=true&"
import script from "./HomeDetails.vue?vue&type=script&lang=js&"
export * from "./HomeDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeDetails.vue?vue&type=style&index=0&id=46d7ae2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d7ae2b",
  null
  
)

component.options.__file = "HomeDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VFlex,
  VLayout,
})
